export default __webpack_public_path__ + "static/media/contactimg.9ba879fa.png";